/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-explicit-any */
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useEffect, useState } from "react";
import { Box, Chip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const AutoComplete = ({
  label,
  suggestions,
  selectedValue,
  onChange,
  sx = {},
}: {
  label: string;
  suggestions: any;
  selectedValue: any;
  onChange: (value: any) => void;
  sx?: object;
}) => {
  const [value, setValue] = useState<any>(null);

  useEffect(() => {
    setValue(selectedValue);
  }, [selectedValue]);

  const handleOnChange = (event: React.SyntheticEvent, newValue: any) => {
    if (typeof newValue !== "string") {
      setValue(newValue);
      onChange(newValue);
    }
  };

  const getLabel = (option: any) => {
    if ("clientName" in option) return option.clientName;
    if ("name" in option) return option.name;
    return "";
  };

  return (
    <Box sx={{ width: 250, ...sx }}>
      <Autocomplete
        disablePortal
        options={
          suggestions?.map((d: any) => ({
            label: getLabel(d),
            ...d,
          })) ?? []
        }
        onChange={handleOnChange}
        clearOnBlur
        freeSolo
        size="small"
        value={
          value
            ? {
                label: getLabel(value),
                ...value,
              }
            : null
        }
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            paddingRight: "8px",
            backgroundColor: "background.paper",
            transition: "all 0.2s ease-in-out",
            "& fieldset": {
              borderColor: "grey.300",
            },
            "&:hover fieldset": {
              borderColor: "primary.main",
            },
            "&.Mui-focused fieldset": {
              borderColor: "primary.main",
              borderWidth: 2,
            },
          },
          "& .MuiAutocomplete-input": {
            padding: "8px 12px",
            fontSize: "0.875rem",
          },
          "& .MuiAutocomplete-endAdornment": {
            right: 8,
          },
          "& .MuiInputLabel-root": {
            fontSize: "0.875rem",
            fontWeight: 500,
            "&.Mui-focused": {
              color: "primary.main",
            },
          },
        }}
        renderOption={(props, option) => {
          const { key, ...otherProps } = props;
          return (
            <li
              key={key}
              {...otherProps}
              style={{
                padding: "10px 16px",
                fontSize: "0.875rem",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <SearchIcon
                  sx={{ fontSize: "1rem", color: "text.secondary" }}
                />
                {option.label}
              </Box>
            </li>
          );
        }}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => {
            const { key, ...tagProps } = getTagProps({ index });
            return (
              <Chip
                key={key}
                label={option.label}
                {...tagProps}
                size="small"
                sx={{
                  backgroundColor: "primary.light",
                  color: "primary.contrastText",
                  fontWeight: 500,
                }}
              />
            );
          })
        }
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder="Search..."
            slotProps={{
              input: {
                ...params.InputProps,
                startAdornment: (
                  <SearchIcon
                    sx={{
                      ml: 1,
                      mr: 0.5,
                      fontSize: "1.25rem",
                      color: "text.secondary",
                    }}
                  />
                ),
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default AutoComplete;
